import { createContext, useContext } from 'react'
import useGetConfigFile from '../Hooks/useGetConfigFile';
import useApi from '../Hooks/useApi';
import LoadingSpinner from '../Components/Components/LoadingSpinner';
import ConfigErrorComponent from '../Components/ErrorBoundary/ConfigErrorComponent';

const ConfigContext = createContext()

export const useConfig = () => {
    return useContext(ConfigContext)
}

const ConfigProvider = ({ children }) => {
    const { apiUrl, dataUrl, loading, error } = useGetConfigFile()
    const { api, logOutTrigger } = useApi(apiUrl)

    if (loading) {
        return <LoadingSpinner fullScreenLoading={true} loadingText='Ładowanie konfiguracji, proszę czekać...' />
    }
    if (error) {
        return <ConfigErrorComponent
            errorHeader='Błąd aplikacji!'
            errorLine1='Błąd podczas ładowania konfiguracji.'
            errorLine2='Spróbuj ponownie później.'
        />
    }
    if (!api) {
        return <ConfigErrorComponent
            errorHeader='Błąd aplikacji!'
            errorLine1='Brak adresu API w konfiguracji!'
        />
    }
    return (
        <ConfigContext.Provider value={{ dataUrl, api, logOutTrigger }}>
            {children}
        </ConfigContext.Provider>
    )
}

export default ConfigProvider

